module.exports = __webpack_public_path__ + "static/media/henry-photo.9c3c82d5.jpg";